(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["horizon-gallery"] && !Shopify.designMode) return;
  try {
    class HorizonGallery extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.index = 0;
      this.paused = false;
      this.pointerStart = null;
      this.track = this.querySelector('[data-hg-track]');
      this.viewport = this.querySelector('[data-hg-viewport]');
      this.slides = Array.from(this.querySelectorAll('[data-hg-slide]'));
      this.prevButton = this.querySelector('[data-hg-prev]');
      this.nextButton = this.querySelector('[data-hg-next]');
      this.pauseButton = this.querySelector('[data-hg-pause]');
      this.pauseText = this.querySelector('[data-hg-pause-text]');
      this.dotsContainer = this.querySelector('[data-hg-dots]');
      this.dialog = this.querySelector('[data-hg-dialog]');
      this.dialogImage = this.querySelector('[data-hg-dialog-image]');
      this.dialogCaption = this.querySelector('[data-hg-dialog-caption]');
      this.mediaQuery = window.matchMedia('(max-width: 749px)');

      if (!this.track || !this.slides.length) {
        this.dataset.empty = 'true';
        return;
      }

      this.dataset.empty = 'false';
      this.buildDots();
      this.bindEvents();
      this.updateMode();
      this.update();
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      if (this.boundResize) window.removeEventListener('resize', this.boundResize);
      if (this.boundVisibility) document.removeEventListener('visibilitychange', this.boundVisibility);
      this.resizeObserver?.disconnect();
    }

    bindEvents() {
      this.prevButton?.addEventListener('click', () => this.goTo(this.index - 1, true));
      this.nextButton?.addEventListener('click', () => this.goTo(this.index + 1, true));
      this.pauseButton?.addEventListener('click', () => this.togglePaused());

      this.boundResize = () => {
        this.updateMode();
        this.update();
      };

      this.boundVisibility = () => {
        if (document.hidden) {
          this.stopAutoplay();
        } else {
          this.startAutoplay();
        }
      };

      window.addEventListener('resize', this.boundResize);
      document.addEventListener('visibilitychange', this.boundVisibility);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          this.updateMode();
          this.update();
        });
        this.resizeObserver.observe(this);
      }

      if (this.dataset.keyboard === 'true') {
        this.addEventListener('keydown', (event) => {
          if (!this.isSlider()) return;
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.goTo(this.index - 1, true);
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.goTo(this.index + 1, true);
          }
        });
      }

      if (this.dataset.drag === 'true') {
        this.viewport?.addEventListener('pointerdown', (event) => {
          if (!this.isSlider()) return;
          this.pointerStart = { x: event.clientX, y: event.clientY };
        });

        this.viewport?.addEventListener('pointerup', (event) => {
          if (!this.pointerStart || !this.isSlider()) return;

          const deltaX = event.clientX - this.pointerStart.x;
          const deltaY = event.clientY - this.pointerStart.y;
          this.pointerStart = null;

          if (Math.abs(deltaX) < 42 || Math.abs(deltaX) < Math.abs(deltaY)) return;
          this.goTo(deltaX > 0 ? this.index - 1 : this.index + 1, true);
        });
      }

      if (this.dataset.pauseHover === 'true') {
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => this.startAutoplay());
      }

      this.querySelectorAll('[data-hg-expand]').forEach((button) => {
        button.addEventListener('click', () => {
          const slide = button.closest('[data-hg-slide]');
          this.openDialog(slide);
        });
      });

      this.querySelector('[data-hg-dialog-close]')?.addEventListener('click', () => this.closeDialog());
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.closeDialog();
      });
    }

    buildDots() {
      if (!this.dotsContainer) return;

      this.dotsContainer.innerHTML = '';
      this.slides.forEach((slide, slideIndex) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'horizon-gallery__dot';
        button.setAttribute('aria-label', `Show image ${slideIndex + 1}`);
        button.addEventListener('click', () => this.goTo(slideIndex, true));
        this.dotsContainer.appendChild(button);
      });
      this.dots = Array.from(this.dotsContainer.children);
    }

    updateMode() {
      const layout = this.dataset.layout || 'grid';
      const mobileLayout = this.dataset.mobileLayout || 'inherit';
      const isMobile = this.isMobileViewport();
      const activeLayout = isMobile && mobileLayout !== 'inherit' ? mobileLayout : layout;

      this.dataset.mobileActive = String(isMobile);
      this.dataset.currentLayout = activeLayout;
      this.dataset.slider = this.isSlider() && this.slides.length > 1 ? 'true' : 'false';

      if (this.viewport) {
        if (this.isSlider()) {
          this.viewport.setAttribute('aria-roledescription', 'carousel');
        } else {
          this.viewport.removeAttribute('aria-roledescription');
        }
      }

      if (!this.isSlider()) {
        this.stopAutoplay();
      } else {
        this.startAutoplay();
      }
    }

    isSlider() {
      return ['slideshow', 'stack', 'coverflow'].includes(this.dataset.currentLayout);
    }

    isMobileViewport() {
      const width = this.getBoundingClientRect().width || this.clientWidth || 0;
      return width > 0 ? width <= 749 : this.mediaQuery.matches;
    }

    goTo(nextIndex, userInitiated = false) {
      if (!this.slides.length) return;

      if (this.dataset.loop === 'true') {
        this.index = (nextIndex + this.slides.length) % this.slides.length;
      } else {
        this.index = Math.max(0, Math.min(nextIndex, this.slides.length - 1));
      }

      if (userInitiated) this.restartAutoplay();
      this.update();
    }

    update() {
      this.style.setProperty('--hg-index', this.index);
      if (this.track) this.track.style.setProperty('--hg-index', this.index);

      this.slides.forEach((slide, slideIndex) => {
        const diff = this.normalizedDiff(slideIndex - this.index);
        const distance = Math.abs(diff);
        const isActive = slideIndex === this.index;
        const slider = this.isSlider();
        const z = Math.max(1, this.slides.length - distance);
        const intensity = Number(this.dataset.effectIntensity || 50) / 50;
        const stackDepth = Number(this.dataset.stackDepth || 3);
        const visible = distance <= stackDepth;

        slide.dataset.hgState = isActive ? 'active' : 'idle';
        if (slider) {
          slide.setAttribute('role', 'group');
          slide.setAttribute('aria-roledescription', 'slide');
          slide.setAttribute('aria-label', `${slideIndex + 1} of ${this.slides.length}`);
          slide.setAttribute('aria-hidden', String(!isActive));
          slide.tabIndex = isActive ? 0 : -1;
        } else {
          slide.removeAttribute('role');
          slide.removeAttribute('aria-roledescription');
          slide.removeAttribute('aria-label');
          slide.removeAttribute('aria-hidden');
          slide.removeAttribute('tabindex');
        }
        slide.style.setProperty('--hg-z', z);
        slide.style.setProperty('--hg-opacity', visible ? Math.max(0, 1 - distance * 0.18) : 0);
        slide.style.setProperty('--hg-stack-x', `${diff * 24 * intensity}px`);
        slide.style.setProperty('--hg-stack-y', `${distance * 18}px`);
        slide.style.setProperty('--hg-stack-rotate', `${diff * -4 * intensity}deg`);
        slide.style.setProperty('--hg-stack-scale', Math.max(0.82, 1 - distance * 0.055));
        slide.style.setProperty('--hg-coverflow-x', `${diff * 190 * intensity}px`);
        slide.style.setProperty('--hg-coverflow-z', `${distance * -80 * intensity}px`);
        slide.style.setProperty('--hg-coverflow-rotate', `${diff * -38 * intensity}deg`);
        slide.style.setProperty('--hg-coverflow-scale', Math.max(0.76, 1 - distance * 0.08));
      });

      this.dots?.forEach((dot, dotIndex) => {
        dot.setAttribute('aria-current', String(dotIndex === this.index));
      });

      if (this.dataset.loop !== 'true') {
        if (this.prevButton) this.prevButton.disabled = this.index === 0;
        if (this.nextButton) this.nextButton.disabled = this.index === this.slides.length - 1;
      }
    }

    normalizedDiff(diff) {
      if (this.dataset.loop !== 'true') return diff;

      const half = this.slides.length / 2;
      if (diff > half) return diff - this.slides.length;
      if (diff < -half) return diff + this.slides.length;
      return diff;
    }

    startAutoplay() {
      const delay = Number(this.dataset.autoplayDelay || 5000);

      if (
        this.dataset.autoplay !== 'true' ||
        this.paused ||
        !this.isSlider() ||
        this.slides.length < 2 ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        return;
      }

      this.stopAutoplay();
      this.timer = window.setInterval(() => this.goTo(this.index + 1), delay);
    }

    stopAutoplay() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }

    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }

    togglePaused() {
      this.paused = !this.paused;
      this.pauseButton?.setAttribute('aria-pressed', String(this.paused));
      if (this.pauseText) this.pauseText.textContent = this.paused ? 'Play' : 'Pause';
      this.paused ? this.stopAutoplay() : this.startAutoplay();
    }

    openDialog(slide) {
      if (!this.dialog || !slide) return;

      const src = slide.dataset.fullSrc;
      const caption = slide.dataset.caption || '';
      const alt = slide.dataset.alt || caption || 'Gallery image';
      if (!src) return;

      this.dialogImage.src = src;
      this.dialogImage.alt = alt;
      this.dialogCaption.textContent = caption;
      this.dialogCaption.hidden = !caption;

      if (typeof this.dialog.showModal === 'function') {
        this.dialog.showModal();
      } else {
        window.open(src, '_blank', 'noopener');
      }
    }

    closeDialog() {
      if (this.dialog?.open) this.dialog.close();
      if (this.dialogImage) this.dialogImage.removeAttribute('src');
    }
  }

  if (!customElements.get('horizon-gallery')) {
    customElements.define('horizon-gallery', HorizonGallery);
  }
  } catch(e) { console.error(e); }
})();

})();
